define.alias("ember-math-helpers/helpers/acosh", "settings/helpers/acosh");